angular.module('impactx.themeworld').controller('ThemeWorldOwningCompanyCtrl', [
    '$scope',
    '$mdDialog',
    'TranslationService',
    'themeFactory',
    'title',
    'data',
    ThemeWorldOwningCompanyCtrl]);

function ThemeWorldOwningCompanyCtrl($scope, $mdDialog, TranslationService, themeFactory , title, data) {
    $scope.abortLabel = TranslationService.get("abort");
    $scope.saveLabel = TranslationService.get("save");
    $scope.data = data;
    $scope.title = title;
    $scope.theme = themeFactory.getTheme();

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.answer = function ()
    {
        $mdDialog.hide();
    };
}